import { ReactNode } from 'react'
import { Link, Head, usePage } from '@inertiajs/react'
import { Toaster } from '@/components/ui/sonner'
import { Button } from '@/components/ui/button'
import { PageProps } from '@/types'


interface PublicLayoutProps {
  children: ReactNode
  title?: string
  fullWidth?: boolean
}

export function PublicLayout({ children, title, fullWidth = false }: PublicLayoutProps) {
  const { flash, auth } = usePage<PageProps>().props
  const isAuthenticated = auth.user !== null

  return (
    <>
      <Head title={title || 'Sidebrief'} />

      {/* Public Navigation Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <Link href="/session/new" className="flex items-center">
              <img src="/sidebrief-logo.png" alt="Sidebrief" className="h-16 w-auto" />
            </Link>

            {/* Auth Links */}
            <div className="flex items-center gap-3">
              {isAuthenticated ? (
                <Link href="/accounts/select">
                  <Button size="sm">
                    Dashboard
                  </Button>
                </Link>
              ) : (
                <>
                  <Link href="/session/new" className="hidden sm:block">
                    <Button variant="ghost" size="sm">
                      Sign In
                    </Button>
                  </Link>
                  <Link href="/registration/new">
                    <Button size="sm">
                      Sign Up
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className={fullWidth ? '' : 'container mx-auto mt-28 px-5'}>
        {(flash.notice || flash.alert) && (
          <div className="mb-5">
            {flash.notice && (
              <p className="py-2 px-3 bg-green-50 text-green-600 font-medium rounded-md inline-block">
                {flash.notice}
              </p>
            )}
            {flash.alert && (
              <p className="py-2 px-3 bg-destructive/10 text-destructive font-medium rounded-md inline-block">
                {flash.alert}
              </p>
            )}
          </div>
        )}
        {children}
      </main>

      <Toaster />
    </>
  )
}
